export default __webpack_public_path__ + "static/media/main-logo.bdf6c25f.svg";